module.exports = __webpack_public_path__ + "static/media/icon-chevron-down.dde26f81.svg";